import React, {useState, useEffect} from 'react'
import { API } from 'aws-amplify';
import 'leaflet.heat/dist/leaflet-heat';
import L, { Map } from 'leaflet';
import { logToDatadog } from '../../../services/datadog';

interface RecentFlightsHeatmapProps {
  mapRef: React.MutableRefObject<Map>;
  cellId: number;
  shouldShowHeatmap: boolean;
}
export const RecentFlightsHeatmap = (props: RecentFlightsHeatmapProps) => {
  const [heatLayer, setHeatLayer] = useState<any>();

  useEffect(() => {
    if (props.mapRef?.current && props.shouldShowHeatmap) {
      addHeatLayer();
    } else {
      heatLayer?.remove();
    }
    return () => {
      heatLayer?.remove();
    };
  }, [props.mapRef, props.shouldShowHeatmap])

  const addHeatLayer = async () => {
    return API.get('api', `/airspace/flightdensity/${props.cellId}`, {})
      .then(data => {
        const layer = (L as any).heatLayer(data, {"blur": 15, "maxZoom": 18, "minOpacity": 0.2, "radius": 25}).addTo(props.mapRef?.current);
        setHeatLayer(layer)
      })
      .catch(err => logToDatadog('error_loading_recent-flight_data', {err}, 'error'))
  };

  return null;
}

export default RecentFlightsHeatmap;
